const APP_ENV = process.env.REACT_APP_ENV;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export { APP_ENV, API_BASE_URL };
